module.exports = __webpack_public_path__ + "img/center_text7.b033f28d.png";